import React from 'react';
import {
  LabelConformanceBadge,
  LabelParticipationBadge,
} from 'components/Labels';
import {Col, Row} from 'reactstrap';
import styles from './styles.module.scss';

function ABComplianceStatus(props) {
  const {data} = props || {};
  const {accreditation_bodies_participation, accreditation_bodies_conformance} =
    data;

  return (
    <section>
      <h3 className={styles['section__title']}>AB Participation Status</h3>
      <p className={styles['compliance__description']}>
        Indicates alignment with IAF standards based on documented participation
        and adherence to mandatory requirements, confirming commitment to
        quality and safety standards.
      </p>

      <Row className="mb-2">
        <Col xs={7} md={3} className={styles['compliance__label']}>
          Participation Status
        </Col>
        <Col xs={5} md={9}>
          <LabelParticipationBadge
            status={accreditation_bodies_participation}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={7} md={3} className={styles['compliance__label']}>
          Conformance Status
        </Col>
        <Col xs={5} md={9}>
          <LabelConformanceBadge status={accreditation_bodies_conformance} />
        </Col>
      </Row>
    </section>
  );
}

export default ABComplianceStatus;
